import { render, staticRenderFns } from "./NewsNotice.vue?vue&type=template&id=97db01a4&scoped=true&"
import script from "./NewsNotice.vue?vue&type=script&lang=ts&"
export * from "./NewsNotice.vue?vue&type=script&lang=ts&"
import style0 from "./NewsNotice.vue?vue&type=style&index=0&id=97db01a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97db01a4",
  null
  
)

export default component.exports